import styled from 'styled-components'

import Loading from './Loading'

const Btn = (props) => {
  const { text, loading, disabled, onClick } = props

  const css = disabled ? 'disabled' : undefined
  const click = disabled ? undefined : onClick
  const content = loading ? <Loading /> : undefined
  return (
    <Button className={css} onClick={click}>
      {content} <Title>{text}</Title>
    </Button>
  )
}

const Button = styled.button`
  width: 100%;
  height: 56px;
  color: white;
  background: ${(p) => p.theme.color.royalBlue};
  border-radius: 30px;
  padding: 0px 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  border: 0px;

  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px;

  &.disabled {
    opacity: 0.4;
  }
`
const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 35px;
  color: ${(p) => p.theme.color.white};

  ${(p) => p.theme.media.mobile_xs} {
    font-size: 12px;
  }
`

export default Btn
